// extracted by mini-css-extract-plugin
export default {"root":"LocalLLMTrust_root__dW1pX","dark":"LocalLLMTrust_dark__lXH4L","icon":"LocalLLMTrust_icon__b1Q4o","logo":"LocalLLMTrust_logo__kGHuX","text":"LocalLLMTrust_text__iItTA"};